import { LISTING } from './content/contentDemoData';

/**
 * Demo catalogue for the Filter page: the OVER/LL listing editions, each with
 * the attributes the Figma bar names (Color / Collection / School / Price).
 * Swatch hexes are catalogue content (garment colours), not DS tokens.
 */

const SCHOOLS = [
  'Katedralskolan', 'Malmö Borgarskola', 'Hvitfeldtska', 'Norra Real', 'Södra Latin', 'Polhemskolan',
  'Spyken', 'Kungsholmens gymnasium', 'Rudbeckianska', 'Thorengruppen', 'Procivitas', 'Viktor Rydberg',
];

const slug = (s) => s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-');

export const FILTER_ATTRIBUTES = [
  {
    id: 'color',
    label: 'Color',
    type: 'options',
    options: [
      { value: 'white', label: 'White', swatch: '#f4f1ec' },
      { value: 'red', label: 'Red', swatch: '#b3262e' },
      { value: 'black', label: 'Black', swatch: '#1b1b1b' },
      { value: 'pink', label: 'Pink', swatch: '#e9a3b8' },
      { value: 'navy', label: 'Navy', swatch: '#1f2a4d' },
    ],
  },
  {
    id: 'collection',
    label: 'Collection',
    type: 'options',
    options: [
      { value: 'classic', label: 'Classic' },
      { value: 'edition', label: 'Edition' },
      { value: 'limited', label: 'Limited' },
    ],
  },
  {
    id: 'school',
    label: 'School',
    type: 'options',
    options: SCHOOLS.map((name) => ({ value: slug(name), label: name })),
  },
  { id: 'price', label: 'Price', type: 'range', min: 0, max: 1000, step: 10, unit: 'kr', field: 'priceValue' },
];

/** Two more, for the "All filters" fold */
export const EXTRA_ATTRIBUTES = [
  {
    id: 'size',
    label: 'Size',
    type: 'options',
    options: ['XS', 'S', 'M', 'L', 'XL'].map((s) => ({ value: s.toLowerCase(), label: s })),
  },
  {
    id: 'fit',
    label: 'Fit',
    type: 'options',
    multiple: false,
    options: [
      { value: 'regular', label: 'Regular' },
      { value: 'oversize', label: 'Oversize' },
    ],
  },
];

export const SORT_OPTIONS = [
  { value: 'recommended', label: 'Recommended' },
  { value: 'newest', label: 'Newest' },
  { value: 'price-asc', label: 'Lowest price' },
  { value: 'price-desc', label: 'Highest price' },
];

export const SORTERS = {
  newest: (a, b) => b.added - a.added,
  'price-asc': (a, b) => a.priceValue - b.priceValue,
  'price-desc': (a, b) => b.priceValue - a.priceValue,
};

const COLOR_BY_ID = { white: 'white', red: 'red', black: 'black', pink: 'pink', navy: 'navy', 'white-2': 'white' };
const PRICES = [299, 349, 399, 449, 499, 599, 699, 799, 249, 549, 649, 899];
const COLLECTIONS = ['classic', 'edition', 'limited'];

/** Twelve cards: the six editions and their two-tone Duo versions, spread over the attributes */
export const FILTER_ITEMS = [...LISTING.items, ...LISTING.items].map((item, i) => ({
  id: `${item.id}-${i}`,
  title: i < 6 ? item.title : `${item.title} Duo`,
  image: item.image,
  imageAlt: item.imageAlt,
  priceValue: PRICES[i],
  price: `${PRICES[i]} kr`,
  // The Duo editions come in their colour + black
  color: i < 6 ? COLOR_BY_ID[item.id] : [COLOR_BY_ID[item.id], 'black'],
  collection: COLLECTIONS[i % 3],
  school: [slug(SCHOOLS[i % SCHOOLS.length]), slug(SCHOOLS[(i + 5) % SCHOOLS.length])],
  size: ['s', 'm', 'l', 'xl'].slice(i % 2, 4 - (i % 3)),
  fit: i % 4 === 0 ? 'oversize' : 'regular',
  added: i,
}));

/** ProductsGrid card props of an item */
export const toCard = ({ id, title, price, image, imageAlt }) => ({ id, title, price, image, imageAlt });
